export const DEALS_STATUSES = {
  ACTIVE: 'active',
  UNDER_CONTRACT: 'under_contract',
  INACTIVE: 'inactive',
};

export const USER_STATUSES = {
  NOT_INVITED: 'not_invited',
  INVITED: 'invited',
  REGISTERED: 'shared',
};

export const MANAGER_TYPES = {
  REALTOR: 'realtor',
  COORDINATOR: 'coordinator',
  ADMIN: 'admin',
};

export const USER_TYPES = {
  ...MANAGER_TYPES,
  CLIENT: 'client',
};

export const REALTORS = {
  PERSONAL_REALTOR: 'personal_realtor',
  CORPORATE_REALTOR: 'corporate_realtor',
};

export const REALTOR_ROLES = {
  OWNER: 'owner',
};

export const CLIENT_ROLES = {
  SELLER: 'seller',
  BUYER: 'buyer',
  NEW_LEAD: 'new_lead',
  NEW_CLIENT: 'new_client',
};

export const ADMIN_GOALS = {
  TEAM_MANAGEMENT: 'team_management',
  PROCESSES_MANAGEMENT: 'processes_management',
  CLIENT_EXPERIENCE: 'client_experience',
};

export const AGENT_GOALS = {
  LEAD_GENERATING: 'lead_generation',
  STREAMLINE_WORKFLOWS: 'streamline_workflows',
  TRANSACTION_MANAGEMENT: 'transaction_management',
};

export const USER_GOALS = {
  ...ADMIN_GOALS,
  ...AGENT_GOALS,
};

export const EXTERNAL_SOURCES = {
  BRIVITY: 'brivity',
  ZAPIER: 'zapier',
  GMAIL: 'gmail',
};

export const EXTERNAL_SOURCES_TO_TEXT = {
  BRIVITY: 'Brivity',
  ZAPIER: 'Zapier',
};

export const COLORS = {
  GREEN: '#97B79F',
  BLUE: 'var(--primary)',
  GRAY: 'var(--gray)',
};

export const STATUS_TO_OBJ = {
  [USER_STATUSES.NOT_INVITED]: {
    dotColor: COLORS.GRAY,
    label: 'Not invited',
  },
  [USER_STATUSES.INVITED]: {
    dotColor: COLORS.BLUE,
    label: 'Invite sent',
  },
  [USER_STATUSES.REGISTERED]: {
    dotColor: COLORS.GREEN,
    label: 'Active',
  },
};

export const STATUSES_SEQUENCE = Object.values(USER_STATUSES);

export const USER_STATUS_OPTIONS = [
  {
    label: 'Not invited',
    value: USER_STATUSES.NOT_INVITED,
  },
  {
    label: 'Invite sent',
    value: USER_STATUSES.INVITED,
  },
  {
    label: 'Active',
    value: USER_STATUSES.REGISTERED,
  },
];

export const AGENT_DELETED = {
  FIRST_NAME: 'AGENT',
  LAST_NAME: 'DELETED',
  FULL_NAME: '[AGENT DELETED]',
};
